import axios from '../interceptor/http'


class parent {
    static pcVersion: String = '0.0.6';
    static pms_get (api,req) {
        let params = req ? Object.entries(req).map(v => v.join('=')).join('&') : '';
        return new Promise((resolve, reject) => {
            // let BASEURL = "/api/";
            // if(api[0] === '/') {
            //     BASEURL = '/api'
            // }
            let BASEURL = "/";
            axios.get(BASEURL+api+'?'+params)
                .then( res => {
                    if(res.status == '200'){
                        resolve(res.data);
                    }else{
                        reject(res.data);
                    }
                })
                .catch(err => {
                    reject(err.data);
                })
        });
    }

   static  pms_post (api,req) {
        return new Promise((resolve, reject) => {
            // let BASEURL = "/api/";
            // if(api[0] === '/') {
            //     BASEURL = '/api'
            // }
            let BASEURL = "/";
            axios.post(BASEURL+api,req)
                .then( res => {
                    if(res.status == '200'){
                        if(res.data.code == "1000"){
                            resolve(res.data.data);
                        }else{
                           reject(res.data)
                        }
                    }else{
                        reject(res.data);
                    }
                })
                .catch(err => {
                    reject(err.data);
                })
        });
    }
}

export default parent;
